import { AppBar, Box, Toolbar, useTheme } from "@mui/material"
import { HeaderTitle } from "components/Header"

export const Header = ({
  backButton = null,
  filterBar = null,
  searchButton = null,
  headerTitle = "",
}) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`AppHeader`]?.styleOverrides || {}
  const {
    root,
    toolbar,
    backButtonContainer,
    titleContainer,
    searchButtonContainer,
    filterSecton,
  } = styleOverrides

  const isRtl = theme.isRtl

  return (
    <AppBar component="nav" sx={root}>
      <Toolbar sx={toolbar}>
        {backButton && (
          <Box sx={backButtonContainer} className={isRtl ? "is-rtl" : ""}>
            {backButton}
          </Box>
        )}
        <Box sx={titleContainer}>
          {headerTitle ? headerTitle : <HeaderTitle />}
        </Box>
        {searchButton && <Box sx={searchButtonContainer}>{searchButton}</Box>}
      </Toolbar>
      {filterBar && <Box sx={filterSecton}>{filterBar}</Box>}
    </AppBar>
  )
}
